require('./brokerDerivativesMovementsView.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');
const Immutable = require('immutable');

// @ helpers
const { formatText, FormattedText, getFinalTitle } = require('core/i18n').i18n;

// @ components
const BrokerTransferOfDerivatives = require('components/broker/brokerTransferOfDerivatives/brokerTransferOfDerivatives');
const { LoadingSection } = require('commonsComponents/loadingSection');

// @ commons
const { OKCover } = require('commonsComponents/OKCover');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { ContentBox } = require('commonsComponents/contentBox');
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
const OKModal = require('components/commons/OKModal/OKModal');

// @constants
const {
    MYPROFILE_BROKER_URL,
    MY_PROFILE_BROKER_DERIVATIVES_MOVEMENTS_WIZARD_URL
} = require('constants/index');

// @actions
const BrokerTransferOfDerivativesActions = require('actions/brokerDerivativesMovements');
const BrokerCreateTransferOfDerivativesAction = require('actions/brokerCreateTransferOfDerivatives');

class BrokerDerivativesMovementsView extends React.Component {
    constructor(props) {
        super(props);

        this.createButton = this.createButton.bind(this);
        this.handleCreateTransferOfDerivatives = this.handleCreateTransferOfDerivatives.bind(this);
    }

    componentDidMount() {
        this.props.onFetching();
    }

    getBreadcrumbData() {
        return [
            {
                text: formatText('breadcrumb-brokerInvestments'),
                url: MYPROFILE_BROKER_URL
            },
            {
                text: formatText('breadcrumb-transferOfDerivatives'),
                url: ''
            }
        ];
    }

    buildContent() {
        const { immDerivativesMovements } = this.props;

        const transferOfDerivativesBoxTitle = (
            <OKBoxTitle value={formatText('broker-transferOfDerivativesViewPendingForToday')} />
        );

        let content;

        if (immDerivativesMovements.get('fetching')) {
            content = <LoadingSection />;
        } else {
            content = this.buildTransferOfDerivativesContent();
        }

        return (
            <ContentBox title={transferOfDerivativesBoxTitle}>
                {content}
            </ContentBox>
        );
    }

    buildContentFooter() {
        const {
            immDerivativesMovements,
            onCancel,
            onCancelModal,
            onConfirmRemove,
            onModify,
            onRemove,
            onSave,
        } = this.props;

        const hasDerivatives = immDerivativesMovements.get('hasDerivatives');
        const editing = immDerivativesMovements.get('editing');

        let footer;

        if (hasDerivatives && editing) {
            const editLoading = immDerivativesMovements.get('editLoading');

            footer = (
                <footer className="broker-derivatives-movements-view__footer">
                    <div className="row">
                        <div className="col-xs-6">
                            <OKButton modifier="link-ghost" onClick={onCancel}>
                                <FormattedText value="broker-transferOfDerivativesCancel" />
                            </OKButton>
                        </div>
                        <div className="col-xs-6 text-right">
                            <OKButton modifier="secondary" onClick={onSave} loading={editLoading}>
                                <FormattedText value="broker-transferOfDerivativesSaveChanges" />
                            </OKButton>
                        </div>
                    </div>
                </footer>
            );
        } else if (hasDerivatives) {
            const showDeleteModal = immDerivativesMovements.get('showDeleteModal');
            const removeLoading = immDerivativesMovements.get('removeLoading');

            footer = (
                <footer className="broker-derivatives-movements-view__footer text-right">
                    <OKModal
                        description="broker-transferOfDerivativesDeleteModalContent"
                        descriptionAlignment="center"
                        footerType="action"
                        isOpen={showDeleteModal}
                        onCloseCallback={onCancelModal}
                        onPrimaryButtonClick={onConfirmRemove}
                        onSecondaryButtonClick={onCancelModal}
                        primaryButtonLoading={removeLoading}
                        primaryButtonText="broker-transferOfDerivativesDeleteModalConfirm"
                        scrollable={false}
                        secondaryButtonText="broker-transferOfDerivativesDeleteModalCancel"
                        title="broker-transferOfDerivativesDeleteModalTitle"
                        titleAlignment="center"
                    />
                    <div className="broker-derivatives-movements-view__delete-button">
                        <OKButton modifier="ghost" onClick={onRemove}>
                            <FormattedText value="broker-transferOfDerivativesDelete" />
                        </OKButton>
                    </div>
                    <div className="broker-derivatives-movements-view__modify-button">
                        <OKButton onClick={onModify}>
                            <FormattedText value="broker-transferOfDerivativesModify" />
                        </OKButton>
                    </div>
                </footer>
            );
        }

        return footer;
    }

    buildSideColumn() {
        return (
            <ContentBox>
                <p><FormattedText value="broker-transferOfDerivativesViewSidebarFirstLine" /></p>
                <p><FormattedText value="broker-transferOfDerivativesViewSidebarSecondLine" /></p>
            </ContentBox>
        );
    }

    buildTransferOfDerivativesContent() {
        const { immDerivativesMovements, immBrokerWallets, onChangeAmount, onChangeConcept } = this.props;

        const originContractNumber = immDerivativesMovements.get('originContractNumber');
        const destinationContractNumber = immDerivativesMovements.get('destinationContractNumber');

        const immOriginFund = immBrokerWallets.get('futuresList').find(
            immFund => immFund.getIn(['cviejo', 'numerodecontrato']) === originContractNumber
        ) || Immutable.Map();
        const immDestinationFund = immBrokerWallets.get('futuresList').find(
            immFund => immFund.getIn(['cviejo', 'numerodecontrato']) === destinationContractNumber
        ) || Immutable.Map();

        const isEmpty = !immDerivativesMovements.get('hasDerivativeTransfer');

        const creationDate = immDerivativesMovements.get('creationDate');

        const originAccountName = immOriginFund.get('descripcion', '').trim();
        const originAccountNumber = immOriginFund.getIn(['ibanComplex', 'codbban']);
        const originAccountBalance = immOriginFund.getIn(['saldoActual', 'importe']);
        const originAccountBalanceCurrency = immOriginFund.getIn(['saldoActual', 'divisa']);

        const destinationAccountName = immDestinationFund.get('descripcion', '').trim();
        const destinationAccountNumber = immDestinationFund.getIn(['ibanComplex', 'codbban']);
        const destinationAccountBalance = immDestinationFund.getIn(['saldoActual', 'importe']);
        const destinationAccountBalanceCurrency = immDestinationFund.getIn(['saldoActual', 'divisa']);

        const amountToTransfer = immDerivativesMovements.get('amountToTransfer');
        const amountToTransferCurrency = immDerivativesMovements.get('amountToTransferCurrency');
        const invalidAmountToTransfer = immDerivativesMovements.get('amountToTransferInvalid');

        const concept = immDerivativesMovements.get('concept');

        const editMode = immDerivativesMovements.get('editing');

        return (
            <section>
                <h4 className="broker-derivatives-movements-view__title">
                    <FormattedText value="broker-transferOfDerivativesFuturesTransfer" />
                </h4>
                <BrokerTransferOfDerivatives
                    isEmpty={isEmpty}
                    showTitle={true}
                    showCreationDate={true}
                    editMode={editMode}
                    creationDate={creationDate}
                    originAccountName={originAccountName}
                    originAccountNumber={originAccountNumber}
                    originAccountBalance={originAccountBalance}
                    originAccountBalanceCurrency={originAccountBalanceCurrency}
                    destinationAccountName={destinationAccountName}
                    destinationAccountNumber={destinationAccountNumber}
                    destinationAccountBalance={destinationAccountBalance}
                    destinationAccountBalanceCurrency={destinationAccountBalanceCurrency}
                    amountToTransfer={amountToTransfer}
                    amountToTransferCurrency={amountToTransferCurrency}
                    invalidAmountToTransfer={invalidAmountToTransfer}
                    amountToTransferErrorMessage={formatText('broker-transferOfDerivativesInvalidAmount')}
                    concept={concept}
                    onChangeAmount={onChangeAmount}
                    onChangeConcept={onChangeConcept}
                />
                {this.buildContentFooter()}
            </section>
        );
    }

    createButton() {
        const { immDerivativesMovements } = this.props;

        if (!immDerivativesMovements.get('hasDerivativeTransfer')) {
            return (
                <OKButton
                    id="btnCreateNewAlertText"
                    modifier="primary"
                    onClick={this.handleCreateTransferOfDerivatives}
                >
                    <FormattedText value="broker-transferOfDerivativesNew" />
                </OKButton>
            );
        }
    }

    handleCreateTransferOfDerivatives() {
        const { immDerivativesMovements } = this.props;

        this.props.onCreateTransferOfDerivatives(immDerivativesMovements.get('originContractNumber'));
        this.props.history.push(MY_PROFILE_BROKER_DERIVATIVES_MOVEMENTS_WIZARD_URL);
    }

    render() {
        const mappingBreadcrumb = this.getBreadcrumbData();
        const createButton = this.createButton();

        return (
            <article className="broker-derivatives-movements-view">
                <OKCover size="medium" section="broker">
                    <OKHeaderSubPage
                        breadcrumbConfig={mappingBreadcrumb}
                        className="broker-derivatives-movements-view__header"
                        finalTitle={getFinalTitle('broker-transferOfDerivativesViewTitle')}
                    >
                        {createButton}
                    </OKHeaderSubPage>
                </OKCover>
                <section id="transferOfDerivativesSection" className="broker-derivatives-movements-view__body">
                    <div className="row no-outside-gutter">
                        <div className="col-xs-8">
                            {this.buildContent()}
                        </div>
                        <div className="col-xs-4">
                            {this.buildSideColumn()}
                        </div>
                    </div>
                </section>
            </article>
        );
    }
}

BrokerDerivativesMovementsView.propTypes = {
    history: PropTypes.object.isRequired,
    immDerivativesMovements: PropTypes.object.isRequired,
    immBrokerWallets: PropTypes.object.isRequired,
    onFetching: PropTypes.func.isRequired,
    onRemove: PropTypes.func.isRequired,
    onConfirmRemove: PropTypes.func.isRequired,
    onModify: PropTypes.func.isRequired,
    onChangeAmount: PropTypes.func.isRequired,
    onChangeConcept: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    onCancelModal: PropTypes.func.isRequired,
    onCreateTransferOfDerivatives: PropTypes.func.isRequired,
    onFetchBrokerMiFIDProduct: PropTypes.func.isRequired,
    onStartConvenienceMiFIDTest: PropTypes.func.isRequired
};

module.exports.constructor = BrokerDerivativesMovementsView;
module.exports.BrokerDerivativesMovementsView = connect(
    (state) => ({
        immDerivativesMovements: state.brokerDerivativesMovements,
        immBrokerWallets: state.brokerWallets
    }),
    {
        onFetching: BrokerTransferOfDerivativesActions.fetch,
        onRemove: BrokerTransferOfDerivativesActions.toggleDeleteModal,
        onConfirmRemove: BrokerTransferOfDerivativesActions.remove,
        onModify: BrokerTransferOfDerivativesActions.modify,
        onChangeAmount: BrokerTransferOfDerivativesActions.changeAmount,
        onChangeConcept: BrokerTransferOfDerivativesActions.changeConcept,
        onSave: BrokerTransferOfDerivativesActions.save,
        onCancel: BrokerTransferOfDerivativesActions.cancel,
        onCancelModal: BrokerTransferOfDerivativesActions.toggleDeleteModal,
        onCreateTransferOfDerivatives: BrokerCreateTransferOfDerivativesAction.beginOperation
    }
)(withRouter(BrokerDerivativesMovementsView));
